export function parseTopic(topic) {
    const parts = topic.split(':');
    const tag = parts.slice(1).join(':') || parts[0];
    const prefix = parts[0] ?? 'unknown';
    return { tag, prefix };
}
